import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-slide-edit-keymap-spacing-style-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './keymap-spacing-style-form.component.html',
    styleUrls: ['./keymap-spacing-style-form.component.scss'],
    standalone: false
})
export class KeymapSpacingStyleFormComponent {
  #isSubmitted = signal(false);
  #keymapStyle: FlatModels.KeymapStyleEntityModels.KeymapStyle;
  keymapStyleForm = new FormGroup(
    {
      columnDistance: new FormControl(0),
      rowDistance: new FormControl(0),
      indexWidth: new FormControl(0),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.KeymapStyleEntityModels.KeymapStyleSchema.pick({
          columnDistance: true,
          rowDistance: true,
          indexWidth: true,
        })
      )
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Keymap Style
    this.slideAuthorFacade.currentSelectedSlideKeymapStyle$.pipe(takeUntilDestroyed()).subscribe((keymapStyle) => {
      this.#keymapStyle = structuredClone(keymapStyle)
      if (keymapStyle) {
        this.keymapStyleForm.reset(this.#keymapStyle);
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.keymapStyleForm.invalid) {
      return;
    }
    this.#isSubmitted.set(true);
    
    const keymapStyle = assign(this.#keymapStyle, this.keymapStyleForm.value);
    this.slideAuthorFacade.requestUpdateKeymapStyle(keymapStyle, 'history.keymap_update_style').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.keymapStyleForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
